import { render } from "./BadgedIcon.vue?vue&type=template&id=1c360572&scoped=true"
import script from "./BadgedIcon.vue?vue&type=script&lang=js"
export * from "./BadgedIcon.vue?vue&type=script&lang=js"

import "./BadgedIcon.vue?vue&type=style&index=0&id=1c360572&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c360572"]])

export default __exports__